(() => {
  const html = document.documentElement; html.classList.add('sr-js');
  // The promo text is a merchant setting, so the header's real height is measured
  // into the token that scroll-padding and the sticky mission heading rely on.
  const header = document.querySelector('.sr-site-header');
  const setHeaderH = () => header && html.style.setProperty('--sr-header-h', Math.round(header.getBoundingClientRect().height) + 'px');
  if (header) { setHeaderH(); addEventListener('resize', setHeaderH); }
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const all = document.querySelectorAll('.sr-reveal');
  const hero = document.querySelector('.sr-home .sr-hero');
  const ready = () => hero && hero.classList.add('is-ready');
  if (reduce) { all.forEach(el => el.classList.add('is-in')); ready(); return; }
  (document.fonts ? document.fonts.ready : Promise.resolve()).then(ready); setTimeout(ready, 300);
  const io = new IntersectionObserver(entries => entries.forEach(e => {
    if (!e.isIntersecting) return; e.target.classList.add('is-in'); io.unobserve(e.target);
  }), { threshold: .12, rootMargin: '0px 0px -8% 0px' });
  all.forEach(el => io.observe(el));

  // Safety net. The observer's threshold is a share of the element, so a block
  // taller than the viewport, or one the browser jumps past when a link lands on
  // an anchor, can sit at opacity 0 forever. Sweep anything already on screen so
  // content can never be invisible, and stop once everything has been revealed.
  let pending = Array.prototype.slice.call(all);
  let queued = false;
  const sweep = () => {
    queued = false;
    pending = pending.filter(el => {
      if (el.classList.contains('is-in')) return false;
      const r = el.getBoundingClientRect();
      // Anything at or above the fold counts, including blocks the jump scrolled
      // straight past (negative top), which the observer never sees intersect.
      if (r.top < innerHeight * 0.95) { el.classList.add('is-in'); io.unobserve(el); return false; }
      return true;
    });
    if (!pending.length) {
      removeEventListener('scroll', onScroll); removeEventListener('resize', onScroll);
    }
  };
  const onScroll = () => { if (!queued) { queued = true; requestAnimationFrame(sweep); } };
  addEventListener('scroll', onScroll, { passive: true });
  addEventListener('resize', onScroll);
  onScroll();
})();
